'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDirective$002dPath$0024$0024anon$002463 from "./presto.types$-Directive-Path$$anon$63.js";
import * as $j_presto$002etypes$0024$002dDirective$002dPath$0024$0024anon$002464 from "./presto.types$-Directive-Path$$anon$64.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DirectivePath$() {
  this.c6A = null;
  this.c6B = false;
  this.c6y = null;
  this.c6z = false;
  this.c6E = null;
  this.c6F = false;
  this.c6C = null;
  this.c6D = false;
  this.c6G = null;
  this.c6H = false;
}
export { $c_Lpresto_types$DirectivePath$ as $c_Lpresto_types$DirectivePath$ };
$p = $c_Lpresto_types$DirectivePath$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectivePath$;
/** @constructor */
function $h_Lpresto_types$DirectivePath$() {
}
export { $h_Lpresto_types$DirectivePath$ as $h_Lpresto_types$DirectivePath$ };
$h_Lpresto_types$DirectivePath$.prototype = $p;
$p.cJ1 = (function() {
  if ((!this.c6B)) {
    this.c6A = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c6B = true;
  }
  return this.c6A;
});
$p.vj = (function() {
  if ((!this.c6z)) {
    this.c6y = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.c6z = true;
  }
  return this.c6y;
});
$p.cJK = (function() {
  if ((!this.c6F)) {
    this.c6E = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c6F = true;
  }
  return this.c6E;
});
$p.ct1 = (function() {
  if ((!this.c6D)) {
    this.c6C = new $j_presto$002etypes$0024$002dDirective$002dPath$0024$0024anon$002463.$c_Lpresto_types$DirectivePath$$anon$63(this);
    this.c6D = true;
  }
  return this.c6C;
});
$p.cK0 = (function() {
  if ((!this.c6H)) {
    this.c6G = new $j_presto$002etypes$0024$002dDirective$002dPath$0024$0024anon$002464.$c_Lpresto_types$DirectivePath$$anon$64(this);
    this.c6H = true;
  }
  return this.c6G;
});
var $d_Lpresto_types$DirectivePath$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectivePath$, "presto.types$DirectivePath$", ({
  ZL: 1,
  D: 1
}));
export { $d_Lpresto_types$DirectivePath$ as $d_Lpresto_types$DirectivePath$ };
var $n_Lpresto_types$DirectivePath$;
function $m_Lpresto_types$DirectivePath$() {
  if ((!$n_Lpresto_types$DirectivePath$)) {
    $n_Lpresto_types$DirectivePath$ = new $c_Lpresto_types$DirectivePath$();
  }
  return $n_Lpresto_types$DirectivePath$;
}
export { $m_Lpresto_types$DirectivePath$ as $m_Lpresto_types$DirectivePath$ };
//# sourceMappingURL=presto.types$-Directive-Path$.js.map
